import styled from 'styled-components';
import {palette} from '@/styles';
import IconUndo from './icon-undo.svg';

interface IProps {
  categories?: string[];
  activeTab?: string;
  prevButtonText?: string; // 뒤로가기 버튼 존재 시 라벨값
  onClick?(e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>): void;
}

export const CategoryTabs = ({
  categories,
  activeTab,
  prevButtonText,
  onClick,
}: IProps) => {
  if (!categories) {
    return null;
  }

  return (
    <Root>
      {!!prevButtonText?.length && (
        <PrevButton onClick={onClick}>
          <img src={IconUndo} alt="이전으로" />
          {prevButtonText}
        </PrevButton>
      )}
      <Tabs>
        {categories.map((key) => (
          <Tab
            key={key}
            data-key={key}
            disabled={activeTab === key}
            onClick={onClick}
          >
            {key}
          </Tab>
        ))}
      </Tabs>
    </Root>
  );
};

const Root = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  background-color: ${palette.white};
  overflow: hidden;
  overflow-x: auto;
  border-bottom: 1px solid ${palette.gray150};
  font-size: 14px;
  font-weight: 500;
`;

const PrevButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0 16px;
  white-space: nowrap;
  color: ${palette.gray800};
  gap: 4px;
  border-right: 1px solid ${palette.gray150};
`;

const Tab = styled.button`
  border-bottom: 4px solid transparent;
  white-space: nowrap;
  padding: 16px 0 10px;
  cursor: pointer;
  &:disabled {
    border-color: ${palette.teal100};
    color: ${palette.teal100};
  }
`;

const Tabs = styled.div`
  color: ${palette.gray500};
  padding: 0 16px;
  display: flex;
  gap: 20px;
`;
